interface SeatAllocationStoreState {
  availableSeats: number;
  warningDialog: {
    show: boolean;
    seatAllocated?: boolean;
    canEditUsers?: boolean;
    canEditBilling?: boolean;
  }
}

/**
 * Simple client store implemented via reactivity api.
 * Might switch to Pinia in the future if more store features are needed.
 * @see https://vuejs.org/guide/scaling-up/state-management.html#simple-state-management-with-reactivity-api
 */
export const seatAllocationStore = reactive<SeatAllocationStoreState>({
  availableSeats: 0,
  warningDialog: {
    show: false,
  },
});
